<template>
	<div
		class="login__animation login__animation--expand"
		:class="{ 'login__animation--aborted': aborted }"
	>
		<div class="login__animation--display">
			<img :src="require('@/assets/centiva_light.svg')">
		</div>
		<div class="login__animation--ripple" />
	</div>
</template>

<script>
export default {
	name: 'LoginAnimation',
	props: {
		aborted: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
};
</script>

<style scoped lang="scss" src="./login-animation.scss" />
